import ReactGA from "react-ga4";
import { isLocalhost } from "util";

const TrackingCode = "G-R7RVT5Y2W3";

export const initializeAnalytics = () => {
	// Initialize tracking
	ReactGA.initialize(TrackingCode);
	// disable GA:
	if (isLocalhost) {
		window["ga-disable-" + TrackingCode] = true;
	}
};

export const disableAnalytics = () => {
	window["ga-disable-" + TrackingCode] = true;
};

export const setUserProperty = (key, value) => {
	ReactGA.gtag('set', 'user_properties', { [key]: value });
};

export const trackEvent = (name, params = {}) => {
	ReactGA.event(name, params);
};
